import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { DeviceService } from '../../../core/services/device.service';
import { InputFocusService } from '../../../core/services/input-focus.service';
import { OnRenderedModule } from '../../directives/on-rendered/on-rendered.module';
import { EIconPath } from '../../shared/enums/icons.enum';
import { IconModule } from '../icon/icon-module';
import { TSearchBoxSize } from './search-box.component.consts';
import { iconMap } from '../../shared/enums/icon-map';

@Component({
  selector: 'pp-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, IconModule, OnRenderedModule],
})
export class SearchBoxComponent {
  @ViewChild('input', { static: false }) inputElement: ElementRef;

  @Input() ppPlaceholder: string;
  @Input() ppFocusOnInit = false;
  @Input() ppSize: TSearchBoxSize = 'default';
  @Input() ppColor = '#101828';
  @Input() set ppValue(value: string) {
    this.searchBox = value ?? '';
  }
  @Output() ppAction = new EventEmitter<string>();

  isMobile = false;
  isTablet = false;

  searchBox = '';
  focused = false;
  EIconPath = EIconPath;
  iconMap = iconMap;

  constructor(
    private deviceService: DeviceService,
    private inputFocusService: InputFocusService,
  ) {
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
  }

  onInputRendered(element: HTMLElement): void {
    if (this.ppFocusOnInit && !this.isMobile && !this.isTablet) {
      this.inputFocusService.immediateFocus(element);
    }
  }

  onInputFocus(): void {
    this.focused = true;
  }

  onInputBlur(): void {
    this.focused = false;
  }

  clear(): void {
    this.searchBox = '';

    this.filterItems();
  }

  filterItems(): void {
    this.ppAction.emit(this.searchBox);
  }

  onEnter(): void {
    this.inputElement.nativeElement.blur();
  }
}
